var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraineere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 8.41669C10.9665 8.41669 11.75 7.63318 11.75 6.66669C11.75 5.70019 10.9665 4.91669 10 4.91669C9.0335 4.91669 8.25 5.70019 8.25 6.66669C8.25 7.63318 9.0335 8.41669 10 8.41669Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0003 12.4167C7.52533 12.4167 4.91699 13.6334 4.91699 14.1667V15.0834H15.0837V14.1667C15.0837 13.6334 12.4753 12.4167 10.0003 12.4167Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.8333C7.77467 10.8333 3.33301 11.95 3.33301 14.1666V16.6666H16.6663V14.1666C16.6663 11.95 12.2247 10.8333 9.99967 10.8333ZM15.083 15.0833H4.91634V14.1666C4.91634 13.6333 7.52467 12.4166 9.99967 12.4166C12.4747 12.4166 15.083 13.6333 15.083 14.1666V15.0833ZM9.99967 9.99998C11.8413 9.99998 13.333 8.50831 13.333 6.66665C13.333 4.82498 11.8413 3.33331 9.99967 3.33331C8.15801 3.33331 6.66634 4.82498 6.66634 6.66665C6.66634 8.50831 8.15801 9.99998 9.99967 9.99998ZM9.99967 4.91665C10.9663 4.91665 11.7497 5.69998 11.7497 6.66665C11.7497 7.63331 10.9663 8.41665 9.99967 8.41665C9.03301 8.41665 8.24967 7.63331 8.24967 6.66665C8.24967 5.69998 9.03301 4.91665 9.99967 4.91665Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraineere);
export default __webpack_public_path__ + "static/media/traineere.9d196335a66d862ea67a9fb6f05b7e61.svg";
export { ForwardRef as ReactComponent };